module.exports = __webpack_public_path__ + "img/close-white.5b1ada9c.svg";